import MatchResultsView from "../MatchResultsView";
import Navigation from "../../../components/Navigation/Navigation";
import {Navigate, Route, Routes, useParams} from "react-router-dom";
import { MOCK_SCORE_ARRAYS } from "./mockScores";
import { useEffect, useState } from "react";
import { useYear } from "../../../context/YearContext";
import { TournamentLink } from "../Tournament/TournamentLink";
import { getWinnerId } from "../Tournament/TournamentView";

export const subTitleMap = {
    "145": "Kungdo",
    "90": "TarscaShild",
    "70": "Puta",
    "30": "Zamby"
};

export const matchTypeMap = {
    "individual_preliminaries": "PRE",
    "individual_round16": "16",
    "individual_round8": "8",
    "individual_round4": "4",
    "individual_round3": "3",
    "individual_round2": "2"
};

// 컬러 표시
export const topRankCountMap = {
    "individual_preliminaries": "16",  // 예선 -> 16강
    "individual_round16": "8",         // 16강 -> 8강
    "individual_round8": "4",          // 8강 -> 4강
    "individual_round4": "2",          // 4강 -> 결승
    "individual_round3": "1",          // 3/4위전 -> 3위
    "individual_round2": "1"           // 결승 -> 우승
};

// 본선: 노란 줄 = 대진표에서 이긴 선수 (round: 대진 라운드, next: 진출자가 올라가는 라운드)
const winnerRoundMap = {
    "individual_round16": { round: "round16", next: "round8" },
    "individual_round8": { round: "round8", next: "round4" },
    "individual_round4": { round: "round4", next: "round2" },
    "individual_round3": { round: "round3" },
    "individual_round2": { round: "round2" }
};

// 대진표에서 이긴 선수들의 선수 번호
const useWinners = (round, gender, distance, year, enabled) => {
    const [winners, setWinners] = useState([]);

    useEffect(() => {
        setWinners([]);
        const stage = winnerRoundMap[round];
        if (!enabled || !stage) return;

        let cancelled = false;
        new TournamentLink()
            .request(gender, distance, year)
            .then(({ tournament }) => {
                if (cancelled) return;
                const nextRound = stage.next ? tournament[stage.next] || [] : undefined;
                const numbers = (tournament[stage.round] || []).flatMap((match) => {
                    const winnerId = getWinnerId(match, nextRound);
                    const winner = match?.players.find((p) => p.player_id === winnerId);
                    return winner ? [String(winner.player_number)] : [];
                });
                setWinners(numbers);
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, [round, gender, distance, year, enabled]);

    return winners;
};

const View = ({ useMock = false }) => {
    const { round, category } = useParams();
    const [ gender, distance ] = category.split("-distance");
    const { year } = useYear();
    const winners = useWinners(round, gender, distance, year, !useMock);

    return (
        <MatchResultsView
            matchType={matchTypeMap[round]}
            event={distance}
            gender={gender}
            subTitle={subTitleMap[distance]}
            topRankCount={topRankCountMap[round]}
            winners={useMock ? undefined : winners}
            mockScoreArray={useMock ? MOCK_SCORE_ARRAYS[gender] : undefined}
        />
    );
};

const Individual = () => {
    const { round } = useParams();

    const tabs = [
        { path: "m-distance145", label: "M_145M(Kungdo)" },
        { path: "m-distance90", label: "M_90M(TarscaShild)" },
        { path: "m-distance70", label: "M_70M(Puta)" },
        { path: "m-distance30", label: "M_30M(Zamby)" },
        { path: "f-distance145", label: "F_145M(Kungdo)" },
        { path: "f-distance90", label: "F_90M(TarscaShild)" },
        { path: "f-distance70", label: "F_70M(Puta)" },
        { path: "f-distance30", label: "F_30M(Zamby)" },
    ];

    return (
        <>
            <Navigation
                tabs={tabs}
                basePath={`/match-results/${round}`}
                variant="tab"
            />

            <Routes>
                <Route path="/" element={<Navigate to="m-distance145" replace />} />
                <Route path=":category" element={<View />} />
                {/* 테스트용 숨김 URL: 화면은 실제와 동일, 데이터만 가상 선수 100명 */}
                <Route path=":category/test" element={<View useMock />} />
            </Routes>
        </>
    );
};
export default Individual;
